var _clipPath, _clipPath2, _clipPath3, _clipPath4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 362 270",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.333,226.292c-29.968,6.7 -147.417,-151.868 -131.602,-194.38c15.814,-42.513 78.072,-28.566 115.244,36.086c37.172,64.652 46.325,151.595 16.358,158.294Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.086,-21.024l101.606,292.332l-121.376,42.187l-101.606,-292.332l121.376,-42.187Z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.84,250.934l-80.155,-230.615l106.431,-36.993l80.155,230.616l-106.431,36.992Z",
    style: {
      fill: "#8991dc"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.167,63.424c9.428,26.773 -138.146,161.664 -182.034,153.855c-43.888,-7.81 -60.975,-62.001 0.173,-107.039c61.149,-45.037 172.433,-73.589 181.861,-46.816Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.313,-16.336l-305.983,153.604l62.634,124.77l305.984,-153.604l-62.635,-124.77Z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.472,235.223l228.512,-114.713l-49.326,-98.259l-228.512,114.713l49.326,98.259Z",
    style: {
      fill: "#ff9b21"
    }
  }))))), /*#__PURE__*/React.createElement("rect", {
    x: 116.707,
    y: 53.282,
    width: 123.111,
    height: 157.134,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.963,
    y: 77.103,
    width: 123.111,
    height: 157.134,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.258,73.522l0,-25.706l-136.063,0l0,167.094l27.213,0l0,25.707l136.063,0l0,-167.095l-27.213,0Zm-122.457,128.535l0,-141.388l108.851,0l0,12.853l-95.244,0l0,128.535l-13.607,0Zm136.063,25.707l-108.85,0l0,-141.388l108.85,0l0,141.388Z",
    style: {
      fill: "#b3b3b3",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.423,
    y: 105.656,
    width: 13.606,
    height: 12.853,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.636,
    y: 105.656,
    width: 40.819,
    height: 12.853,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.423,
    y: 135.647,
    width: 13.606,
    height: 12.853,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.636,
    y: 135.647,
    width: 40.819,
    height: 12.853,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.423,
    y: 165.639,
    width: 13.606,
    height: 12.853,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.636,
    y: 165.639,
    width: 40.819,
    height: 12.853,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.423,
    y: 195.63,
    width: 13.606,
    height: 12.853,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.636,
    y: 195.63,
    width: 40.819,
    height: 12.853,
    style: {
      fill: "#b3b3b3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.b7d490c38d0354197c6757003bfbc90a.svg";
export { ForwardRef as ReactComponent };